import React from "react";
import { Helmet } from "react-helmet-async";
import { Section, SectionTitle } from "../components/UIBits";
import { TOURNAMENT, CATEGORY_YEARS } from "../lib/constants";
import { useT } from "../lib/i18n";

export default function RulesPage() {
    const { t } = useT();
    const RULES = [
        { title: t("rules.r1_title"), body: t("rules.r1_body") },
        { title: t("rules.r2_title"), body: t("rules.r2_body") },
        { title: t("rules.r3_title"), body: t("rules.r3_body") },
        { title: t("rules.r4_title"), body: t("rules.r4_body") },
        { title: t("rules.r5_title"), body: t("rules.r5_body") },
        { title: t("rules.r6_title"), body: t("rules.r6_body") },
        { title: t("rules.r7_title"), body: t("rules.r7_body") },
        { title: t("rules.r8_title"), body: t("rules.r8_body") },
        { title: t("rules.r9_title"), body: t("rules.r9_body") },
        { title: t("rules.r10_title"), body: t("rules.r10_body") },
        { title: t("rules.r11_title"), body: t("rules.r11_body") },
        { title: t("rules.r12_title"), body: t("rules.r12_body") },
    ];
    return (
        <div data-testid="rules-page">
            <Helmet><title>{`${t("rules.title_pre")} — ${TOURNAMENT.name}`}</title></Helmet>
            <Section>
                <SectionTitle kicker={t("rules.kicker")} title={t("rules.title_pre")} accent={t("rules.title_accent")} />

                <div className="glass-card p-6 mb-10 border-l-4 border-[#7FD93C]" data-testid="categories-info">
                    <div className="label-mini mb-2 text-[#7FD93C]">{t("rules.cats_label")}</div>
                    <h2 className="font-display text-3xl uppercase tracking-widest mb-5">{t("rules.cats_heading")}</h2>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
                        {TOURNAMENT.categories.map((c) => (
                            <div key={c} className="bg-black/40 p-4 border-t-2 border-[#4FE0D5]">
                                <div className="font-display text-2xl uppercase tracking-wider text-[#7FD93C]">{c}</div>
                                <div className="label-mini mt-1">{t("rules.born_in")}</div>
                                <div className="font-mono text-lg text-white mt-1">{CATEGORY_YEARS[c]}</div>
                            </div>
                        ))}
                    </div>
                    <div className="text-xs text-white/50 mt-4">{t("rules.cats_footer")}</div>
                </div>

                <div className="glass-card p-6 mb-10 border-l-4 border-[#4FE0D5]" data-testid="format-info">
                    <div className="label-mini mb-2 text-[#4FE0D5]">{t("rules.format_label")}</div>
                    <div className="flex flex-wrap items-baseline gap-4">
                        <div className="font-display text-6xl tracking-tight text-[#7FD93C]">3 vs 3</div>
                        <div className="text-white/70 text-lg">{t("rules.format_body")}</div>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 gap-5">
                    {RULES.map((r, i) => (
                        <div key={i} className="glass-card p-6 border-l-4 border-[#4FE0D5]">
                            <div className="label-mini mb-2">{t("rules.article")} {i + 1}</div>
                            <h3 className="font-display text-2xl uppercase tracking-wide mb-3">{r.title}</h3>
                            <p className="text-sm text-white/70 leading-relaxed">{r.body}</p>
                        </div>
                    ))}
                </div>
            </Section>
        </div>
    );
}
